import { render, staticRenderFns } from "./TelegramChannelDetail.vue?vue&type=template&id=4f41a58e&scoped=true"
import script from "./TelegramChannelDetail.vue?vue&type=script&lang=js"
export * from "./TelegramChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TelegramChannelDetail.vue?vue&type=style&index=0&id=4f41a58e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f41a58e",
  null
  
)

export default component.exports